export default {
	common: {
		tip: '提示',
		addSuccess: '添加成功',
		editSuccess: '编辑成功',
		removeSuccess: '删除成功',
		stateSuccess: '切换成功',
		sendSuccess: '发送成功',
		sendError: '请求失败',
		noData: '暂无数据',
		confirm: '确认',
		cancel: '取消',
		deleteTip: '此操作将永久删除该记录, 是否继续?',
		orderTip: '确定补单, 是否继续?'
	},
	tip: {
		imgIndex: '此处限传 （1） 张（尺寸要求800*800 格式要求jpg/png/jpeg 大小要求1mb 内',
		payIcon: '此处建议 （1） 张（尺寸要求176*176 格式要求jpg/png/jpeg 大小要求 300kb',
		imgProduct: '限传（20）张（尺寸要求800*800 格式要求jpg/png/jpeg 大小要求 1mb内',
		limitFile: '当前限制选择 1 个文件，本次选择了',
		gxzl: '个文件，共选择了',
		gwj: '个文件'
	}
};
